// extracted by mini-css-extract-plugin
export default {"ourLeadershipBlock":"styles_ourLeadershipBlock__EUdfh","detailBlock":"styles_detailBlock__5uD7r","title":"styles_title__EnkJA","advisors":"styles_advisors__HTPTi"};